import { SettingsPage } from "@/features/settings";

export default function SettingsRoutePage() {
  return <SettingsPage />;
}
